import styles from "./style.module.scss";

import { useEffect, useRef, useState } from "react";
import { Input, Label } from "reactstrap";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { setDocumentComments } from "@/store/slices/eDocumentSlides";
import { HiddenableContainer } from "@components/layout/HiddenableContainer";
import DynamicForm, { DynamicFormRef } from "@mavichpe/dynamic-forms";
import CommentsFormConfig from "./form";

type EdocumentCommentsProps = {
  useToggle?: boolean,
  fieldTitle?: string
}

type DocumentComments = {
  comment: string,
}

const EdocumentComments = (props: EdocumentCommentsProps) => {
  const { useToggle = true, fieldTitle } = props
  const dispatch = useAppDispatch();
  const formRef = useRef<DynamicFormRef>(null);
  const [isVisible, setVisible] = useState<boolean>(!useToggle);
  const eDocumentComments = useAppSelector(state => state.eDocument.documentComments)
  const Wrapper = useToggle ? HiddenableContainer : "div"
  const currentFormRef = formRef.current

  useEffect(() => {
    formRef.current?.setFormValue("comments", eDocumentComments, "String")
    if (eDocumentComments && eDocumentComments?.length > 0) {
      setVisible(true)
    }
  }, [eDocumentComments, currentFormRef])

  const onInputChange = async (name: keyof DocumentComments, value: any) => {
    dispatch(setDocumentComments(value))
  }

  const getFormConfig = () => {
    const referenceInput = CommentsFormConfig.sections.flatMap(s => s.fields).flat().find(f => f.name === "comments")
    if (fieldTitle && referenceInput) {
      referenceInput.label = fieldTitle;
    }
    return CommentsFormConfig
  }

  return (
    <>
      {useToggle && (
        <>
          <Input
            id="add-comments"
            type="checkbox"
            checked={isVisible}
            onChange={(e) => setVisible(e.target.checked)}
          />

          <Label className="ps-3"
            for="add-comments"
          >
            Agregar Comentarios
          </Label>
        </>
      )}

      <Wrapper
        show={isVisible}>
        <DynamicForm<DocumentComments>
          ref={formRef}
          // Sin id, dynamic-forms le da al editor un id aleatorio (`i_<nanoid>`) y no hay
          // forma estable de direccionar TinyMCE desde los E2E. Solo se monta un bloque de
          // comentarios por documento, asi que el id fijo no colisiona.
          id="documentComments"
          innerForm={true}
          formConfig={getFormConfig()}
          onInputChange={onInputChange}
        >
        </DynamicForm>
      </Wrapper>

    </>

  )
}

export default EdocumentComments;